import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ImagesModule } from 'lib/images/images.module.js';
import { TypographyModule } from 'lib/typography/index.js';
import { AvatarModule } from '../avatar/index.js';
import { ButtonModule } from '../buttons/index.js';
import { ConfirmModule } from '../confirm/confirm.module.js';
import { DividerModule } from '../divider/index.js';
import { AppFlexModule } from '../flex/index.js';
import { FormInputsModule } from '../form-inputs/index.js';
import { IconModule } from '../icons/index.js';
import { MessagesModule } from '../messages/index.js';
import { TagModule } from '../tag/index.js';
import { TooltipModule } from '../tooltip/tooltip.module.js';
import { TableComponent } from './table.component.js';
import { LinkModule } from '../link/link.module.js';
import { CardModule } from '../card/card.module.js';
import { SimpleTableModule } from '../simple-table/simple-table.module.js';
import { HoverModule } from '../hover/index.js';

@NgModule({
	declarations: [TableComponent],
	exports: [TableComponent],
	imports: [
		CommonModule,
		RouterModule,
		IconModule,
		AppFlexModule,
		DividerModule,
		ImagesModule,
		ButtonModule,
		TypographyModule,
		TooltipModule,
		AvatarModule,
		FormInputsModule,
		TagModule,
		ConfirmModule,
		MessagesModule,
		LinkModule,
		CardModule,
		SimpleTableModule,
		HoverModule
	]
})
export class TableModule {}
